import React, { Component, Fragment } from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Slide,
    AppBar,
    Toolbar,
    Box
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import CloseIcon from '@mui/icons-material/Close';
import { DownloadRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

// FIXME checkout https://mui.com/components/use-media-query/#using-material-uis-breakpoint-helpers
const withMobileDialog = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="lg" fullScreen={props.fullScreen} />;

const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    //   color: theme.palette.grey[500],
    },
  });

function Transition(props) {
    return <Slide direction="up" {...props} />;
}
class DialogMui extends Component{
    
    render(){
        const { open, title, children, close, classes, disabledSubmit, submitTitle, appBar, fullScreen, scroll, secondaryAction, secondSubmitActionButton, disabledSecondarySubmit, submitSecondaryTitle, appBarColor } = this.props;

        return (
            <Dialog
                open={true}
                onClose={(event, reason) => {(reason != "backdropClick" && close())}}
                aria-labelledby="form-dialog-title"
                maxWidth={this.props.maxWidth || "sm"}
                fullScreen={fullScreen}
                fullWidth
                TransitionComponent={Transition}
                scroll={scroll || "body"}
                sx={{
                    zIndex: 10002,
                    '& .MuiBackdrop-root': {
                        zIndex: 10002,
                    },
                    '& .MuiDialog-container': {
                        zIndex: 10002,
                    },
                    '& .MuiDialog-paper': {
                        zIndex: 10002,
                    },
                }}
            >   
                {appBar ? 
                    <AppBar style={{position: 'relative'}} color={appBarColor || "secondary"}>
                        <Toolbar>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" color="inherit">
                                {title}
                            </Typography>
                            {secondaryAction}
                            {close ? (
                                <IconButton
                                    aria-label="Close"
                                    // className={classes.closeButton}
                                    onClick={close}
                                    size="large"
                                    // edge="start"
                                >
                                    <CloseIcon />
                                </IconButton>
                            ) : null}
                        </Toolbar>
                    </AppBar>

                :
                    <Fragment>
                        <DialogTitle className={classes.root}>
                            <Typography variant="h6">{title}</Typography>
                            {secondaryAction ? (
                                secondaryAction
                            ) : null}
                            {close ? (
                                <IconButton
                                    aria-label="Close"
                                    className={classes.closeButton}
                                    onClick={close}
                                    size="large">
                                    <CloseIcon />
                                </IconButton>
                            ) : null}
                        </DialogTitle>
                        <p style={{ borderBottom: "1px solid goldenrod", marginLeft: "10px", marginRight: "10px"}} />
                    </Fragment>
                }
                <DialogContent style={{backgroundColor: appBar && "#fffbfb"}}>
                    {/* <Box p={1}></Box> */}
                    {children}
                </DialogContent>
                
                {/* { this.props.submitAction &&
                    <DialogActions>
                        <Button variant="contained" onClick={this.props.submitAction} color="secondary" disabled={disabledSubmit}>
                            {submitTitle || "Valider"}
                        </Button>
                        <Button onClick={close}>
                            Annuler
                        </Button>
                    </DialogActions>
                } */}
                { this.props.submitAction &&
                    <DialogActions
                    style={{backgroundColor: appBar && "#fffbfb"}}
                    >
                        <LoadingButton
                            onClick={this.props.submitAction}
                            loading={disabledSubmit}
                            disabled={disabledSubmit}
                            variant="contained"
                            color="secondary"
                        >
                            {submitTitle || "Valider"}
                        </LoadingButton>
                        {secondSubmitActionButton &&
                            <Button
                                onClick={this.props.secondSubmitActionButton}
                                // loading={disabledSubmit}
                                disabled={disabledSecondarySubmit || disabledSubmit}
                                variant="contained"
                                color="error"
                            >
                                {submitSecondaryTitle || "Valider"}
                            </Button>
                        }
                        <Button onClick={close}>
                            Annuler
                        </Button>
                    </DialogActions>
                }
            </Dialog>
        );
    }
}

export default withMobileDialog()(withStyles(styles)(DialogMui)) ;